import { ThemeProvider } from "@material-ui/core/styles";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { muiTheme } from "app/muiTheme";
import UpdateInProgress from "app/UpdateInProgress/UpdateInProgress";
import { ErrorBoundary } from "components/ErrorBoundary";
import DictionaryTools from "app/DictionaryTools/DictionaryTools";
import { LocalizationProvider } from "contexts/LocalizationContext";
import { OnboardingContextProvider } from "contexts/OnboardingContext";
import { ToastProvider } from "contexts/ToastContext";
import { UserContextProvider } from "contexts/UserContext";
import {
  createBrowserRouter,
  createRoutesFromChildren as createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";
import { getErrorComponents } from "services/util";
import "./App.scss";
import { Layout } from "./Layout";
import { queryClient } from "./global";
import { RouteList } from "./routing/RouteList";
import useHeartbeat from "./useHeartbeat";
import useNewVersionToast from "./useNewVersionToast";

export function AppShell() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={muiTheme}>
        <RouterProvider router={router} />
      </ThemeProvider>

      {/* Disabled in production build */}
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}

export const router = createBrowserRouter(
  createRoutesFromElements(
    <Route
      path="*"
      element={
        <UserContextProvider>
          <LocalizationProvider>
            <ToastProvider>
              <OnboardingContextProvider>
                <App />
              </OnboardingContextProvider>
            </ToastProvider>
          </LocalizationProvider>
        </UserContextProvider>
      }
    />
  )
);

function App() {
  const { apiResponding, pingServer } = useHeartbeat();
  useNewVersionToast();

  return (
    <div className="App">
      <ErrorBoundary fallback={getErrorComponents("Something went wrong.")}>
        {apiResponding ? (
          <DictionaryTools>
            <Layout>
              <RouteList />
            </Layout>
          </DictionaryTools>
        ) : (
          <UpdateInProgress pingServer={pingServer} />
        )}
      </ErrorBoundary>
    </div>
  );
}
